<div id="container" class="p-grid p-md-offset-2">
    <article>
        <div class="p-md-10">
        <div class="p-md-10">
        <h1>MyFEUT - Web Application</h1>
        <p>In this video, I show how I have developed a web application designed and based on the way that Faculty of Economy, University 
            of Tirana, Albania is organized.
            To develop this application, I used <i>Spring Boot and Angular 8, as well as PostgreSQL, PrimeNG and git. </i>
            <mark>The special feature about this application is that students get instant messaging on Slack when there is a grade release.</mark>
            They are organized based on the degree they are pursuing and the group they are registered on. 
            Teachers have access only on those groups they give lectures to. They may check on their group's performance at any time. 
            On the other hand, the whole system is managed by an administrator, who is pre-registered in the system. It is 
            the administrator who organizes teachers into departments, registers new students into degrees and groups and manages the timetable,i.e
            which teacher is going to give lectures to which group.
        </p>
        <p><b>Github link: </b><a href="https://github.com/lejdiprifti/gradingsystem" target="_blank">https://github.com/lejdiprifti/gradingsystem</a></p>
        </div>
        <div class="p-md-10">
            <iframe width="100%" height="415" src="https://www.youtube.com/embed/JUGLqg-LJJU" frameborder="0" 
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
    </div>
    </article>
    <div class="fb-share-button" data-href="https://lejdiprifti.web.app" data-layout="button_count" data-size="small"><a target="_blank" href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fdevelopers.facebook.com%2Fdocs%2Fplugins%2F&amp;src=sdkpreparse" class="fb-xfbml-parse-ignore">Share</a></div>
</div>